/**
 * CLNF mobile bottom nav + Shop Now sheet.
 * Hardcoded from ConvertCart experiment 90034942 (vanilla JS, no jQuery).
 */
(function () {
  'use strict';

  if (window.__clnfBottomNavBound) return;
  window.__clnfBottomNavBound = true;

  var ARROW_SRC = '';

  /* --- Shop Now dialog focus management (WCAG 2.4.3 / 4.1.2) -------------- */

  // Elements inside the panel that can take keyboard focus.
  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]),' +
    ' select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // The Shop Now trigger, so closing the panel can put focus back on it.
  var triggerEl = null;

  // The category row that opened the current sub-view, so backing out of the
  // sub-view returns focus to where the user left off.
  var lastCategoryLink = null;

  var SUB_LINKS = {
    'bulk-foods': {
      label: 'Bulk Foods',
      href: '/collections/bulk-foods',
      items: [
        { label: 'Beans', href: '/collections/beans' },
        { label: 'Lentils', href: '/collections/lentils' },
        { label: 'Flours & Mixes', href: '/collections/flour' },
        { label: 'Grains & Rice', href: '/collections/grains' },
        { label: 'Oats', href: '/collections/flaked-grains' }
      ]
    },
    'fruits-1': {
      label: 'Fruits',
      href: '/collections/fruits-1',
      items: [
        { label: 'Dried Fruit', href: '/collections/dried-fruit' },
        { label: 'Juice', href: '/collections/juice' }
      ]
    },
    'healthy-beauty': {
      label: 'Health & Beauty',
      href: '/collections/healthy-beauty',
      items: [
        { label: 'Supplements', href: '/collections/supplements' },
        { label: 'Personal Care', href: '/collections/healthy-beauty' }
      ]
    },
    nuts: {
      label: 'Nuts & Seeds',
      href: '/collections/nuts',
      items: [
        { label: 'Nuts', href: '/collections/nuts' },
        { label: 'Seeds', href: '/collections/seeds' },
        { label: 'Nut & Seed Butters', href: '/collections/nut-seed-butters' },
        { label: 'Trail Mix', href: '/collections/nut-mixes' }
      ]
    },
    snacks: {
      label: 'Snacks & Sweets',
      href: '/collections/fruits',
      items: [
        { label: 'Carob & Sweets', href: '/collections/carob-candy' },
        { label: 'Honey', href: '/collections/honey' },
        { label: 'Jams', href: '/collections/jams' },
        { label: 'Sweeteners', href: '/collections/other-sweetners' },
        { label: 'Savory Snacks', href: '/collections/crackers-snacks' },
        { label: 'Meat Alternatives', href: '/pages/search?q=meat' }
      ]
    },
    kitchenware: {
      label: 'Kitchenware',
      href: '/collections/kitchenware',
      items: [
        { label: 'Grain Mills', href: '/pages/search?q=nutrimil' },
        { label: 'Kitchen Knives', href: '/collections/kitchen-knives' },
        { label: 'Cutting Boards', href: '/collections/cutting-boards' },
        { label: 'The Sprout Spout', href: '/products/the-sprout-spout-old-listing' }
      ]
    }
  };

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  // Belt and braces with the CSS `visibility: hidden` on the closed panel:
  // visibility removes the subtree from the tab order everywhere, inert also
  // blocks pointer events and hides it from the accessibility tree.
  function setInert(el, on) {
    if (!el) return;
    if (on) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  function focusEl(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      el.focus();
    }
  }

  function isOpen(sheet) {
    return !!sheet && sheet.classList.contains('cc-sheet-open');
  }

  function isSubOpen(slider) {
    return !!slider && slider.classList.contains('cc-show-sub');
  }

  // Both panes are always laid out (the slider translates between them), so the
  // off-screen pane is kept inert and left out of the focus trap. The close
  // button sits in the header, ahead of both panes in DOM order.
  function focusablesInPanel(sheet, slider) {
    var items = [];
    var closeBtn = qs('.cc-shop-panel-close', sheet);
    if (closeBtn) items.push(closeBtn);
    var pane = qs(isSubOpen(slider) ? '.cc-pane-sub' : '.cc-pane-main', sheet);
    if (pane) items = items.concat(qsa(FOCUSABLE_SELECTOR, pane));
    return items;
  }

  // Slides back to the category list. moveFocus is true when the user asked for
  // it (Back button / Escape) and false when we are tearing the panel down.
  function showMainPane(sheet, slider, moveFocus) {
    if (slider) slider.classList.remove('cc-show-sub');
    setInert(qs('.cc-pane-sub', sheet), true);
    setInert(qs('.cc-pane-main', sheet), false);
    if (moveFocus) {
      focusEl(lastCategoryLink || qs('.cc-shop-panel-close', sheet));
    }
    lastCategoryLink = null;
  }

  function removeConvertCartDuplicates() {
    qsa('.cc-bottom-nav-90034942:not([data-clnf-bottom-nav])').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
    qsa('.cc-shop-overlay:not([data-clnf-bottom-nav])').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
    qsa('.cc-shop-panel:not([data-clnf-bottom-nav])').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
  }

  function openSheet(overlay, sheet, slider) {
    setInert(sheet, false);
    sheet.classList.add('cc-sheet-open');
    overlay.classList.add('cc-sheet-open');
    document.body.classList.add('cc-sheet-open-90034942');
    if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
    // Dialog behaviour: focus has to enter the panel, otherwise it stays on the
    // trigger and keyboard/AT users never reach the content.
    focusEl(focusablesInPanel(sheet, slider)[0]);
  }

  function closeSheet(overlay, sheet) {
    sheet.classList.remove('cc-sheet-open');
    overlay.classList.remove('cc-sheet-open');
    document.body.classList.remove('cc-sheet-open-90034942');
    setInert(sheet, true);
    if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
  }

  // restoreFocus is false when the click that closed the panel is also going to
  // navigate away (the other bottom-nav links).
  function closeAll(overlay, sheet, slider, restoreFocus) {
    closeSheet(overlay, sheet);
    showMainPane(sheet, slider, false);
    if (restoreFocus) focusEl(triggerEl);
  }

  function openSubPanel(slug, sheet, slider) {
    var data = SUB_LINKS[slug];
    if (!data) return;
    if (!data.items.length) {
      window.location.href = data.href;
      return;
    }

    var title = qs('.cc-sub-panel-title', sheet);
    var list = qs('.cc-sub-panel-list', sheet);
    if (!title || !list) return;

    title.textContent = data.label;
    list.textContent = '';

    var viewAllLi = document.createElement('li');
    var viewAll = document.createElement('a');
    viewAll.className = 'cc-sub-view-all';
    viewAll.href = data.href;
    var viewAllText = document.createElement('span');
    viewAllText.textContent = 'View All ' + data.label;
    viewAll.appendChild(viewAllText);
    if (ARROW_SRC) {
      var viewAllArrow = document.createElement('span');
      viewAllArrow.className = 'cc-sub-link-arrow';
      var viewAllImg = document.createElement('img');
      viewAllImg.src = ARROW_SRC;
      viewAllImg.alt = 'arrow';
      viewAllArrow.appendChild(viewAllImg);
      viewAll.appendChild(viewAllArrow);
    }
    viewAllLi.appendChild(viewAll);
    list.appendChild(viewAllLi);

    data.items.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'cc-sub-panel-link';
      a.href = item.href;
      var label = document.createElement('span');
      label.textContent = item.label;
      a.appendChild(label);
      if (ARROW_SRC) {
        var arrow = document.createElement('span');
        arrow.className = 'cc-sub-link-arrow';
        var img = document.createElement('img');
        img.src = ARROW_SRC;
        img.alt = 'arrow';
        arrow.appendChild(img);
        a.appendChild(arrow);
      }
      li.appendChild(a);
      list.appendChild(li);
    });

    if (slider) slider.classList.add('cc-show-sub');
    setInert(qs('.cc-pane-main', sheet), true);
    setInert(qs('.cc-pane-sub', sheet), false);
    // View change: land focus on the Back button, which is the first control in
    // the pane that just slid in.
    focusEl(qs('.cc-sub-back-btn', sheet));
  }

  function init() {
    removeConvertCartDuplicates();

    var nav = qs('.cc-bottom-nav-90034942[data-clnf-bottom-nav]');
    var overlay = qs('.cc-shop-overlay[data-clnf-bottom-nav]');
    var sheet = qs('.cc-shop-panel[data-clnf-bottom-nav]');
    var slider = qs('.cc-panel-slider', sheet);
    if (!nav || !overlay || !sheet) {
      // Elements not found; retry after a short delay in case DOM is still settling
      setTimeout(init, 100);
      return;
    }

    ARROW_SRC = sheet.getAttribute('data-arrow-src') || '';
    document.body.classList.add('cc-stickyNav90034942');

    // Guard: ensure the activating class stays on body even if other code removes it
    // (e.g., if a modal or overlay removes it, restore it for mobile nav visibility)
    if (typeof MutationObserver === 'function') {
      var bodyClassObserver = new MutationObserver(function () {
        if (!document.body.classList.contains('cc-stickyNav90034942')) {
          document.body.classList.add('cc-stickyNav90034942');
        }
      });
      bodyClassObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      // Clean up observer after 30s to avoid overhead for the page's lifetime
      setTimeout(function () {
        bodyClassObserver.disconnect();
      }, 30000);
    }

    // The panel starts closed: keep it (and the off-screen sub-pane) out of the
    // tab order in case the markup ever ships without the inert attributes.
    setInert(sheet, true);
    setInert(qs('.cc-pane-sub', sheet), true);
    setInert(qs('.cc-pane-main', sheet), false);

    triggerEl = qs('.cc-shop-trigger', nav);
    if (triggerEl) {
      triggerEl.setAttribute('aria-expanded', 'false');
      triggerEl.addEventListener('click', function (e) {
        e.preventDefault();
        openSheet(overlay, sheet, slider);
      });
    }

    overlay.addEventListener('click', function () {
      closeAll(overlay, sheet, slider, true);
    });

    var closeBtn = qs('.cc-shop-panel-close', sheet);
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeAll(overlay, sheet, slider, true);
      });
    }

    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest && e.target.closest('.cc-shop-panel-link');
        if (!link || !sheet.contains(link)) return;
        e.preventDefault();
        e.stopPropagation();
        var slug = link.getAttribute('data-collection');
        if (!slug) return;
        lastCategoryLink = link;
        openSubPanel(slug, sheet, slider);
      },
      true
    );

    var subHeader = qs('.cc-sub-panel-header', sheet);
    if (subHeader) {
      subHeader.addEventListener('click', function () {
        showMainPane(sheet, slider, true);
      });
    }

    // Trap Tab / Shift+Tab inside the panel while it is open. Bound on the
    // panel, so it only runs when focus is already inside it.
    sheet.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' && e.keyCode !== 9) return;
      if (!isOpen(sheet)) return;
      var items = focusablesInPanel(sheet, slider);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          focusEl(last);
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        focusEl(first);
      }
    });

    // Escape backs out one level at a time so it mirrors the on-screen Back
    // button: sub-view first, then the whole panel (restoring focus).
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc' && e.keyCode !== 27) return;
      if (!isOpen(sheet)) return;
      if (isSubOpen(slider)) {
        showMainPane(sheet, slider, true);
        return;
      }
      closeAll(overlay, sheet, slider, true);
    });

    qsa('.cc-nav-item:not([data-nav="shop"]) a', nav).forEach(function (a) {
      a.addEventListener('click', function () {
        closeAll(overlay, sheet, slider, false);
      });
    });

    // If ConvertCart re-injects after our bind, strip the duplicates.
    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function () {
        removeConvertCartDuplicates();
      });
      observer.observe(document.body, { childList: true, subtree: false });
      setTimeout(function () {
        observer.disconnect();
      }, 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
